<app-loader *ngIf="isDisabled"></app-loader>
<ul ngbNav #nav="ngbNav" [(activeId)]="active" class="stepper-nav" [destroyOnHide]="false">
    <li [ngbNavItem]="1">
        <button ngbNavLink><i class="bi bi-people-fill"></i></button>
        <span class="stepper-text">Client Group</span>
        <ng-template ngbNavContent><br>
            <div class="card">
                <div class="card-header">
                    Client Group
                </div>
                <div class="card-body">
                    <div class="row m-1">
                        <div class="col-md-4 px-1">
                            <label class="Label">Customer Code</label>
                            <input name="customercode" type="text" [(ngModel)]="CustomerCode" class="form-control"
                                disabled />
                        </div>
                        <div class="col-md-4 px-1">
                            <label class="Label">Customer Name<span class="text-danger">*</span></label>
                            <input name="customername" type="text" [(ngModel)]="CustomerName" class="form-control"
                                maxlength="100" />
                        </div>
                        <!-- <div class="col-md-4 px-1">
                            <label class="Label">Rate Applicable</label>
                            <ng-select name="rateapplicable" [items]="RateApplicableLoad"
                                (change)="onSelectChange('RateApplicable')" [(ngModel)]="RateApplicableID"
                                bindLabel="RateApplicableName" bindValue="RateApplicableID">
                                <ng-option *ngFor="let segment of RateApplicableLoad"
                                    [value]="segment.RateApplicableID">
                                    {{ segment.RateApplicableName }}
                                </ng-option>
                            </ng-select>
                        </div> -->
                        <div class="col-md-4 px-1">
                            <label class="Label">Rate Applicable</label>
                            <ng-select name="rateapplicable" [items]="RateApplicableLoad" bindLabel="RateApplicableName"
                                bindValue="RateApplicableID" [(ngModel)]="RateApplicableID"
                                placeholder="Select Rate Applicable">
                            </ng-select>
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md-4 px-1">
                            <label class="Label">Client Owner</label>
                            <!-- <ng-select name="clientowner" [items]="ClientOwnerLoad" bindLabel="UserName"
                                bindValue="UserMasterID" (change)="onSelectChange('ClientOwner')"
                                [(ngModel)]="ClientOwnerID">
                                <ng-option *ngFor="let segment of ClientOwnerLoad" [value]="segment.UserMasterID">
                                    {{ segment.UserName }}
                                </ng-option>
                            </ng-select> -->
                            <ng-select name="clientowner" [items]="ClientOwnerLoad" bindLabel="UserName"
                                bindValue="UserMasterID" [(ngModel)]="ClientOwnerID" placeholder="Select Client Owner">
                            </ng-select>
                        </div>
                        <div class="col-md-3 px-1">
                            <label class="Label">Office Type</label>
                            <ng-select name="officetype" [items]="ClientOwnerLoad" bindLabel="UserName"
                                bindValue="UserMasterID" placeholder="Select Office Type">
                            </ng-select>
                        </div>
                        <div class="col-md-2 mx-2"><br>
                            <label class="Label" style="margin-left: 3%;">
                                Admin Charges :
                                <input type="checkbox" name="admincharg" [(ngModel)]="AdminCharges" ngbCheckbox />
                            </label>
                        </div>
                        <div class="col-md-auto mx-2"><br>
                            <label class="Label">
                                Active :
                                <input type="checkbox" name="active" [(ngModel)]="Active" ngbCheckbox />
                            </label>
                        </div>
                        <!-- <div class="col-md-auto mx-2"><br>
                            <label class="Label">
                                Is Compliance :
                                <input class="mt-1" type="checkbox" name="compliance" [(ngModel)]="IsComplaince" ngbCheckbox />
                            </label>
                        </div> -->
                    </div>
                </div>
                <div class="card-footer">
                    <div class="row">
                        <div class="col">
                            <div class="row">
                                <label class="Label"></label>
                            </div>
                            <div class="row">
                                <label class="Label"></label>
                            </div>
                            <div class="row">
                            </div>
                            <div class="row">
                            </div>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-outline-secondary btn-sm mx-2" [disabled]="isDisabled"
                                (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Cancel':'Loading...'}}</button>&nbsp;
                            <button class="btn btn-sm btn-primary" name="btn1" (click)="goToNextTab('Tab1')"><i
                                    class="bi bi-save"> </i>
                                Save & Next</button> 
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </li>
    <li [ngbNavItem]="2">
        <button ngbNavLink><i class="bi bi-ticket-detailed-fill"></i></button>
        <span class="stepper-text">Basic Details</span>
        <ng-template ngbNavContent><br>
            <div class="card">
                <!-- <div class="card-body"> -->
                <!-- <div class="card">
                    <div class="card-header">
                        Party Details
                    </div>
                    <div class="card-body">
                        <div class="row m-1">
                            <div class="col-md-4 px-1">
                                <label class="Label">Alias Name</label>
                                <input name="aliasname" [(ngModel)]="AliasName" type="text" class="form-control"
                                    maxlength="100" />
                            </div>
                            <div class="col-md-4 px-1">
                                <label class="Label">Email</label>
                                <input name="email" type="email" [(ngModel)]="Email" class="form-control"
                                    maxlength="100" />
                            </div>
                        </div>
                        <div class="row m-1">
                            <div class="col-md-7 px-1">
                                <label class="Label">Website</label>
                                <input name="website" type="text" [(ngModel)]="WebSite" class="form-control"
                                    maxlength="50" />
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="card">
                    <div class="card-header">
                        Party Subgroup
                    </div>
                    <div class="card-body">
                        <div class="row m-1">
                            <div class="col-md-6 px-1">
                                <label class="Label">Control A/C <span class="text-danger">*</span></label>
                                <!-- <ng-select name="controlac" [items]="ControlAccLoad" bindLabel="GLName"
                                        bindValue="GLCode" (change)="onSelectChange('ControlAc')"
                                        [(ngModel)]="ControlACCode">
                                        <ng-option *ngFor="let segment of ControlAccLoad" [value]="segment.GLCode">
                                            {{ segment.GLName }}
                                        </ng-option>
                                    </ng-select> -->
                                <ng-select name="controlac" [items]="ControlAccLoad" bindLabel="GLName"
                                    bindValue="GLCode" [(ngModel)]="ControlACCode"
                                    (change)="onSelectChange('ControlAc')" placeholder="Select Control A/C">
                                </ng-select>
                            </div>
                            <div class="col-md-6 px-1">
                                <label class="Label">Group</label>
                                <!-- <ng-select name="group" [items]="GroupLoad" bindLabel="GroupName" bindValue="id"
                                        (change)="onSelectChange('Group')" [(ngModel)]="GroupId">
                                        <ng-option *ngFor="let segment of GroupLoad" [value]="segment.id">
                                            {{ segment.GroupName }}
                                        </ng-option>
                                    </ng-select> -->
                                <ng-select name="group" [items]="GroupLoad" bindLabel="GroupName" bindValue="id"
                                    [(ngModel)]="GroupId" placeholder="Select Group">
                                </ng-select>
                            </div>
                        </div>
                        <!-- <div class="row m-1 mt-2">
                            <div class="col-md-6 px-1">
                                <label class="Label">Auto Billing Site Wise :</label>
                                <div class="btn-group btn-group-toggle" style="width: 60%;">
                                    <label class="form-check-label link-dark px-1" style="margin-left: 5%;"
                                        ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]="'1'"
                                            name='autobillingsitewise' [(ngModel)]="AutoBilling">
                                        Yes
                                    </label>
                                    <label class="form-check-label link-dark px-1" style="margin-left: 4%;"
                                        ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]="'0'"
                                            name='autobillingsitewise' [(ngModel)]="AutoBilling">
                                        No
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-6 px-1">
                                <label class="Label">Auto Round Off :</label>
                                <div class="btn-group btn-group-toggle" style="width: 60%;">
                                    <label class="form-check-label link-dark px-1" style="margin-left: 5%;"
                                        ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]="'Y'" name='autoroundoff'
                                            [(ngModel)]="AutoRoundOff">
                                        Yes
                                    </label>
                                    <label class="form-check-label link-dark px-1" style="margin-left: 4%;"
                                        ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]="'N'" name='autoroundoff'
                                            [(ngModel)]="AutoRoundOff">
                                        No
                                    </label>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
                <div class="card">
                    <div class="card-header">
                        Currency Details
                    </div>
                    <div class="card-body">
                        <div class="row m-1">
                            <div class="col-md-6 px-1">
                                <label class="Label">Code<span class="text-danger">*</span></label>
                                <!-- <ng-select name="currencycode" [items]="CurrencyLoad" bindLabel="CurrencyCode"
                                        bindValue="CurrencyName" (change)="onSelectChange('CurrencyLoad')"
                                        [(ngModel)]="CurrencyName">
                                        <ng-option *ngFor="let segment of CurrencyLoad" [value]="segment.CurrencyName">
                                            {{ segment.CurrencyCode }}
                                        </ng-option>
                                    </ng-select> -->
                                <ng-select name="currencycode" [items]="CurrencyLoad" bindLabel="CurrencyCode"
                                    bindValue="CurrencyCode" [(ngModel)]="CurrencyCode" (change)="loadCurrencyName()"
                                    placeholder="Select Code">
                                </ng-select>
                            </div>
                            <div class="col-md-6 px-1">
                                <label class="Label">Name</label>
                                <input name="currencyname" [(ngModel)]="CurrencyName" type="text" class="form-control"
                                    readonly />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header">
                        Other Details
                    </div>
                    <div class="card-body">
                        <div class="row m-1">
                            <div class="col-md-6 px-1">
                                <label class="Label">Credit Terms</label>
                                <input name="creditterms" type="text" [(ngModel)]="CreditTerms" class="form-control"
                                    maxlength="50" />
                            </div>
                            <div class="col-md-6 px-1">
                                <label class="Label">Credit Days</label>
                                <input name="creditdays" type="text" [(ngModel)]="CreditDays" class="form-control"
                                    (input)="filterInput($event)" />
                            </div>
                        </div>
                        <div class="row m-1">
                            <div class="col-md-3 px-1">
                                <label class="Label">PAN No.</label>
                                <input name="Panno" type="text" [(ngModel)]="PANno" [maxlength]="10" class="form-control"
                                    maxlength="15" />
                            </div>
                            <div class="col-md-3 px-1">
                                <label class="Label">TAN No.</label>
                                <input name="Tanno" type="text" [(ngModel)]="TANno" [maxlength]="10" class="form-control"
                                    maxlength="50" />
                            </div>
                            <div class="col-md-3 px-1">
                                <label class="Label">Party-Type<span class="text-danger">*</span></label>
                                <ng-select name="partydebtors" [items]="PartyTypeDebtorsLoad"
                                    bindLabel="TTLPartyTypeName" bindValue="TTLPartyTypeCode"
                                    [(ngModel)]="PartyTypeDebtors" placeholder="Select Party-Type">
                                </ng-select>
                            </div>
                            <div class="col-md-3 px-1">
                                <label class="Label">Alternate Code</label>
                                <input name="alternatecode" type="text" [(ngModel)]="AlternateCode" class="form-control"
                                    maxlength="25" />
                            </div>
                        </div>
                    </div>
                </div>
                <!-- </div> -->
                <div class="card-footer">
                    <div class="row">
                        <div class="col">
                            <div class="row">
                                <label class="Label"></label>
                            </div>
                            <div class="row">
                                <label class="Label"></label>
                            </div>
                            <div class="row">
                            </div>
                            <div class="row">
                            </div>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-outline-secondary btn-sm mx-2" [disabled]="isDisabled"
                                (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Cancel':'Loading...'}}</button>&nbsp;
                            <button class="btn btn-sm btn-primary" name="btn2" (click)="goToNextTab('Tab2')"><i
                                    class="bi bi-save"> </i>
                                Save & Next</button>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </li>
    <li [ngbNavItem]="3">
        <button ngbNavLink><i class="bi bi-house-add-fill"></i></button>
        <span class="stepper-text">Address</span>
        <ng-template ngbNavContent><br>
            <div class="card">
                <div class="card">
                    <div class="card-header">
                        Party Details
                    </div>
                    <div class="card-body">
                        <div class="row m-1">
                            <div class="col-md-6 px-1">
                                <label class="Label">Alias Name</label>
                                <input name="aliasname" [(ngModel)]="AliasName" type="text" class="form-control"
                                    maxlength="100" />
                            </div>
                            <div class="col-md-6 px-1">
                                <label class="Label">Email</label>
                                <input name="email" type="email" [(ngModel)]="Email" class="form-control"
                                    maxlength="100" />
                            </div>
                        </div>
                        <div class="row m-1">
                            <div class="col-md-6 px-1">
                                <label class="Label">Website</label>
                                <input name="website" type="text" [(ngModel)]="WebSite" class="form-control"
                                    maxlength="50" />
                            </div>
                        </div>
                        <div class="row m-1 mt-2">
                            <div class="col-md-6 px-1">
                                <label class="Label">Auto Billing Site Wise :</label>
                                <div class="btn-group btn-group-toggle" style="width: 60%;">
                                    <label class="form-check-label link-dark px-1" style="margin-left: 5%;"
                                        ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]="'1'"
                                            name='autobillingsitewise' [(ngModel)]="AutoBilling">
                                        Yes
                                    </label>
                                    <label class="form-check-label link-dark px-1" style="margin-left: 4%;"
                                        ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]="'0'"
                                            name='autobillingsitewise' [(ngModel)]="AutoBilling">
                                        No
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-6 px-1">
                                <label class="Label">Auto Round Off :</label>
                                <div class="btn-group btn-group-toggle" style="width: 60%;">
                                    <label class="form-check-label link-dark px-1" style="margin-left: 5%;"
                                        ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]="'Y'" name='autoroundoff'
                                            [(ngModel)]="AutoRoundOff">
                                        Yes
                                    </label>
                                    <label class="form-check-label link-dark px-1" style="margin-left: 4%;"
                                        ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]="'N'" name='autoroundoff'
                                            [(ngModel)]="AutoRoundOff">
                                        No
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header">
                        Address Details
                    </div>
                    <div class="card-body">
                        <div class="row m-1">
                            <div class="col-md-4 px-1">
                                <label class="Label">Branch <span class="text-danger">*</span></label>
                                <ng-select name="branch" [items]="BranchNameLoad" bindLabel="DivisionName"
                                    bindValue="DivisionCode" (change)="onSelectChange('Branch')" [(ngModel)]="BranchID"
                                    [disabled]="editMode || Clientdatafrmview.EditSData" placeholder="Select Branch">
                                    <ng-option *ngFor="let segment of BranchNameLoad" [value]="segment.DivisionCode">
                                        {{ segment.DivisionName }}
                                    </ng-option>
                                </ng-select>
                            </div>
                            <div class="col-md-3 px-1" *ngIf="Clientdatafrmview.EditSData">
                                <label class="Label">GL Code</label>
                                <input name="glcode" type="text" [(ngModel)]="GLCode" class="form-control" disabled />
                            </div>
                        </div>
                        <div class="row m-1">
                            <div class="col-md-6 px-1">
                                <label class="Label">Address Line 1 <span class="text-danger">*</span></label>
                                <div class="md-form">
                                    <textarea type="text" id="address1" name="address1" [(ngModel)]="Address1"
                                        class="md-textarea md-textarea-auto form-control" maxlength="100"
                                        style="resize: none; height: 22px;" mdbInput></textarea>
                                </div>
                            </div>
                            <div class="col-md-6 px-1">
                                <label class="Label">Address Line 2</label>
                                <div class="md-form">
                                    <textarea type="text" id="address2" name="address2" [(ngModel)]="Address2"
                                        class="md-textarea md-textarea-auto form-control" maxlength="100"
                                        style="resize: none; height: 22px;" mdbInput></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="row m-1">
                            <div class="col-md-6 px-1">
                                <label class="Label">Address Line 3</label>
                                <div class="md-form">
                                    <textarea type="text" id="address3" name="address3" [(ngModel)]="Address3"
                                        class="md-textarea md-textarea-auto form-control" maxlength="100"
                                        style="resize: none; height: 22px;" mdbInput></textarea>
                                </div>
                            </div>
                            <div class="col-md-6 px-1">
                                <label class="Label">Address Line 4</label>
                                <div class="md-form">
                                    <textarea type="text" id="address4" name="address4" [(ngModel)]="Address4"
                                        class="md-textarea md-textarea-auto form-control" maxlength="100"
                                        style="resize: none; height: 22px;" mdbInput></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="row m-1">
                            <div class="col-md-6 px-1">
                                <label class="Label">City</label>
                                <ng-select name="city" [items]="CityLoad" bindLabel="CityName" bindValue="CityCode"
                                    (change)="onSelectChange('CityLoad')" [(ngModel)]="CityCode"
                                    placeholder="Select City">
                                </ng-select>
                            </div>
                            <div class="col-md-3 px-1">
                                <label class="Label">District</label>
                                <input name="district" type="text" [(ngModel)]="District" class="form-control"
                                    maxlength="50" />
                            </div>
                            <div class="col-md-3 px-1">
                                <label class="Label">State</label>
                                <input name="state" type="text" class="form-control" [(ngModel)]="StateName" readonly />
                            </div>
                        </div>
                        <div class="row m-1">
                            <div class="col-md-4 px-1">
                                <label class="Label">Tel. No.(1)</label>
                                <input name="tel1" type="text" [(ngModel)]="Tel1" class="form-control" maxlength="20" />
                            </div>
                            <div class="col-md-4 px-1">
                                <label class="Label">Tel. No.(2)</label>
                                <input name="tel2" type="text" [(ngModel)]="Tel2" class="form-control" maxlength="20" />
                            </div>
                            <div class="col-md-4 px-1">
                                <label class="Label">Zip Code</label>
                                <input name="zipcode" type="text" [(ngModel)]="ZipCode" class="form-control"
                                    maxlength="7" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header">
                        Contact Person
                    </div>
                    <div class="card-body">
                        <div class="row m-1">
                            <div class="col-md-3 px-1">
                                <label class="Label">Name</label>
                                <input name="contactName" type="text" [(ngModel)]="ContactName" class="form-control"
                                    maxlength="50" />
                            </div>
                            <div class="col-md-3 px-1">
                                <label class="Label">Designation</label>
                                <input name="designation" type="text" [(ngModel)]="Designation" class="form-control"
                                    maxlength="100" />
                            </div>
                            <div class="col-md-3 px-1">
                                <label class="Label">Mobile</label>
                                <input (keypress)="allowOnlyNumbers($event)" (paste)="preventPaste($event)" name="mobleno" type="text" class="form-control" [(ngModel)]="MobileNo"
                                    [maxlength]="10" />
                            </div>
                            <div class="col-md-3 px-1">
                                <label class="Label">LandLine No.</label>
                                <input name="landline" type="text" [(ngModel)]="LandLineNo" class="form-control"
                                    maxlength="50" />
                            </div>
                        </div>
                        <div class="row m-1">
                            <div class="col-md-8 px-1">
                                <label class="Label">EmailID</label>
                                <input name="Email" type="text" [(ngModel)]="ContactPersonEmailID" class="form-control"
                                    maxlength="500" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header">
                        Area Details
                    </div>
                    <div class="card-body">
                        <div class="row m-1">
                            <div class="col-md-6 px-1">
                                <label class="Label">Code <span class="text-danger">*</span></label>
                                <ng-select name="areacode" [items]="AreaLoad" bindLabel="AreaCode" bindValue="AreaName"
                                    (change)="onSelectChange('Area')" [(ngModel)]="AreaName"
                                    [dropdownPosition]="'bottom'">
                                    <ng-template ng-option-tmp let-item="item">
                                        <div>
                                            {{ item.AreaCode }} - {{ item.AreaName }}
                                        </div>
                                    </ng-template>
                                    <ng-template ng-label-tmp let-item="item">
                                        <div>
                                            {{ item?.AreaCode }}
                                        </div>
                                    </ng-template>
                                </ng-select>
                            </div>
                            <div class="col-md-6 px-1">
                                <label class="Label">Name</label>
                                <input name="areaname" type="text" [(ngModel)]="AreaName" class="form-control"
                                    readonly />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card">
                    <div class="card-header">
                        Other Details
                    </div>
                    <div class="card-body">
                        <div class="row m-1">
                            <div class="col-auto px-1">
                                <label class="Label">
                                    Bill To/ Ship To Select
                                    <input type="checkbox" name="billtooption" [(ngModel)]="BillToOption"
                                        (change)="checkboxChanged('BillToShipTo')" ngbCheckbox />
                                </label>
                            </div>
                            <div class="col-md-1"></div>
                            <div class="col-md-1 px-1">
                                <label class="Label">Bill To :</label>
                            </div>
                            <div class="col-md-3 px-1">
                                <div class="btn-group btn-group-toggle" style="width: 100%;">
                                    <label class="form-check-label link-dark px-1" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]="'Site'" name='billto'
                                            [disabled]="!BillToOption" [(ngModel)]="BillTo">
                                        Site
                                    </label>
                                    <label class="form-check-label link-dark px-1" style="margin-left: 4%;"
                                        ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]="'Client'" name='billto'
                                            [disabled]="!BillToOption" [(ngModel)]="BillTo">
                                        Client
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-1 px-1">
                                <label class="Label">Ship To :</label>
                            </div>
                            <div class="col-md-3 px-1">
                                <div class="btn-group btn-group-toggle" style="width: 100%;">
                                    <label class="form-check-label link-dark px-1" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]="'Site'"
                                            [disabled]="!BillToOption" [(ngModel)]="ShipTo" name='shipto'>
                                        Site
                                    </label>
                                    <label class="form-check-label link-dark px-1" style="margin-left: 4%;"
                                        ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]="'Client'"
                                            [disabled]="!BillToOption" [(ngModel)]="ShipTo" name='shipto'>
                                        Client
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="row m-1">
                            <div class="col-md-4 px-1">
                            </div>
                            <div class="col px-1">
                                <label class="Label" [style.color]="BillToOption ? 'green' : 'initial'">This will be
                                    only
                                    Applicable in Sitewise
                                    Billing!</label>
                            </div>
                        </div>
                        <div class="row m-1">
                            <div class="col-md-3 px-1">
                                <label class="Label">Place Of Supply Applicable</label>
                            </div>
                            <div class="col px-1">
                                <div class="btn-group btn-group-toggle" style="width: 100%;">
                                    <label class="form-check-label link-dark px-1" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]="'Y'" name='placeofsupply'
                                            [(ngModel)]="PlaceOfSupplyOpt">
                                        Yes
                                    </label>
                                    <label class="form-check-label link-dark px-1" style="margin-left: 4%;"
                                        ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]="'N'" name='placeofsupply'
                                            [(ngModel)]="PlaceOfSupplyOpt">
                                        No
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card">
                    <div class="card-header">
                        GST Details
                    </div>
                    <div class="card-body">
                        <div class="row m-1">
                            <div class="col-md-3 px-1">
                                <label class="Label">Business Type<span class="text-danger">*</span></label>
                                <ng-select name="businesstype" [(ngModel)]="BussinessType"
                                    (change)="onSelectChange('businesstype')">
                                    <ng-option value="R">Regular</ng-option>
                                    <ng-option value="U">Unregistered</ng-option>
                                    <ng-option value="C">Consumer</ng-option>
                                    <ng-option value="P">Composition</ng-option>
                                </ng-select>
                            </div>
                            <div class="col-md-3 px-1">
                                <label class="Label">GST State<span class="text-danger">*</span></label>
                                <ng-select name="gststate" [items]="GSTStateLoad" bindLabel="GSTStateName"
                                    bindValue="GSTStateCode" (change)="onSelectChange('GSTSelect')"
                                    [(ngModel)]="GSTStateCode" placeholder="Select GST State">
                                </ng-select>
                            </div>
                            <div class="col-md-4 px-1">
                                <label class="Label">GST No.</label>
                                <input name="gstno" type="text" [(ngModel)]="GSTNo" class="form-control"
                                    [disabled]="BussinessType === 'U' || BussinessType === 'C'" maxlength="50" />
                            </div>
                            <!-- <div class="col-md-2 px-1"><br>
                                    <button type="submit" style="width: 30%;" class="btn btn-sm btn-outline-secondary">
                                        <i class="bi bi-info-circle-fill"></i></button>
                                </div> -->
                        </div>
                        <div class="row m-1">
                            <div class="col-md-3 px-1"><br>
                                <label class="Label" style="margin-left: 3%;">
                                    GST Exempt
                                    <input type="checkbox" name="gstExempt" (change)="checkboxChanged('GSTExempt')"
                                        [(ngModel)]="GSTExempt" ngbCheckbox />
                                </label>
                            </div>
                            <div class="col px-1">
                                <label class="Label">Reason for Exemption</label>
                                <div class="md-form">
                                    <textarea type="text" id="reasonofexempt" name="reasonofexempt"
                                        class="md-textarea md-textarea-auto form-control" [disabled]="!GSTExempt"
                                        [(ngModel)]="ReasonGSTExempt" style="resize: none; height: 22px;"
                                        maxlength="500" mdbInput></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="row m-1">
                            <div class="col-md-3 px-1"><br>
                                <label class="Label" style="margin-left: 3%;">
                                    SEZ Customer
                                    <input type="checkbox" name="sezcustomer" (change)="checkboxChanged('SezCust')"
                                        [(ngModel)]="SezCustomer" ngbCheckbox />
                                </label>
                            </div>
                            <div class="col-md-3 px-1">
                                <label class="Label">SEZ GST Exempt</label>
                                <div class="btn-group btn-group-toggle" style="width: 100%;">
                                    <label class="form-check-label link-dark px-1" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]="'Y'" name='sezgstexempt'
                                            [(ngModel)]="SezGstExempt" [disabled]="!SezCustomer">
                                        Yes
                                    </label>
                                    <label class="form-check-label link-dark px-1" style="margin-left: 4%;"
                                        ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]="'N'" name='sezgstexempt'
                                            [(ngModel)]="SezGstExempt" [disabled]="!SezCustomer">
                                        No
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-3 px-1">
                                <label class="Label">SEZ Letter No.</label>
                                <input [disabled]="!SezCustomer" name="sezletter" [(ngModel)]="SezLetterNo" type="text"
                                    maxlength="50" class="form-control" />
                            </div>
                        </div>
                        <div class="row m-1">
                            <div class="col-md-3 px-1">
                                <label class="Label" style="margin-left: 3%;">
                                    RCM Applicable
                                    <input type="checkbox" name="rcmapplicable" [(ngModel)]="RCMApplicable"
                                        ngbCheckbox />
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col">
                                <div class="row">
                                </div>
                                <div class="row">
                                </div>
                                <div class="row">
                                </div>
                            </div>
                            <div class="col-auto">
                                <button type="submit" class="btn btn-sm btn-primary" (click)="Add()">
                                    {{editMode ?'Update':'Add'}}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header">
                        Data
                    </div>
                    <div class="card-body">
                        <table datatable [dtOptions]="this.dtoptions" width="100%" [dtTrigger]="dtTrigger"
                            class="customeDatatable table table-bordered">
                            <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">GL Code</th>
                                    <th scope="col">Branch</th>
                                    <th scope="col">Address 1</th>
                                    <th scope="col">City</th>
                                    <th scope="col">State</th>
                                    <th scope="col">Area Name</th>
                                    <th scope="col">Edit</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let address of AddressTable; let i = index">
                                    <th scope="row">{{ i + 1 }}</th>
                                    <td>{{ address.GLCode}}</td>
                                    <td>{{ address.BranchCode }}</td>
                                    <td>{{ address.Address1 }}</td>
                                    <td>{{ address.CityName }}</td>
                                    <td>{{ address.StateName }}</td>
                                    <td>{{ address.AreaName }}</td>
                                    <td>
                                        <button class="btn btn-sm btn-group-toggle" style="border: none;"
                                            (click)="onEditClick(address, i)">
                                            <i class="bi bi-pencil-square text-warning"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="row">
                        <div class="col">
                            <div class="row">
                                <label class="Label"> </label>
                            </div>
                            <div class="row">
                                <label class="Label"> </label>
                            </div>
                            <div class="row">
                            </div>
                            <div class="row">
                            </div>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-outline-secondary btn-sm mx-2" [disabled]="isDisabled"
                                (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Cancel':'Loading...'}}</button>&nbsp;
                            <button class="btn btn-sm btn-primary" name="btn3" (click)="goToNextTab('Tab3')"><i
                                    class="bi bi-save"> </i>
                                Save & Next</button>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </li>
    <li [ngbNavItem]="4">
        <button ngbNavLink><i class="bi bi-cloud-haze2-fill"></i></button>
        <span class="stepper-text">Addition Details</span>
        <ng-template ngbNavContent><br>
            <div class="card">
                <div class="card">
                    <div class="card-header">
                        TDS Details
                    </div>
                    <div class="card-body">
                        <div class="row m-1">
                            <div class="col-md-3 px-1">
                                <label class="Label">Section Type</label>
                                <div class="btn-group btn-group-toggle" style="width: 100%;">
                                    <label class="form-check-label link-dark px-1" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]="''"
                                            [(ngModel)]="SectionType" (change)="onSelectionChange()" name='gstdetails'>
                                        NA
                                    </label>
                                    <label class="form-check-label link-dark px-1" style="margin-left: 4%;"
                                        ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]="'1'"
                                            [(ngModel)]="SectionType" (change)="onSelectionChange()" name='gstdetails'>
                                        Fixed
                                    </label>
                                    <label class="form-check-label link-dark px-1" style="margin-left: 4%;"
                                        ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]="'0'"
                                            [(ngModel)]="SectionType" (change)="onSelectionChange()" name='gstdetails'>
                                        Variable
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-2 px-1">
                                <label class="Label">Nature of Payment(TDS)</label>
                                <ng-select name="section" [items]="SectionLoad" bindLabel="SectionCode"
                                    bindValue="SectionName" [disabled]="SectionType === ''"
                                    (change)="onSelectChange('SectionSelect')" [(ngModel)]="SectionName">
                                    <ng-option *ngFor="let segment of SectionLoad" [value]="segment.SectionName">
                                        {{ segment.SectionCode }}
                                    </ng-option>
                                </ng-select>
                            </div>
                            <div class="col-md-3 px-1">
                                <label class="Label">Name</label>
                                <input name="sectionname" [(ngModel)]="SectionName" [disabled]="SectionType === ''"
                                    type="text" class="form-control" readonly />
                            </div>
                            <div class="col-md-4 px-1">
                                <label class="Label" style="margin-left: 6%;">TDS On :</label>
                                <div class="btn-group btn-group-toggle" style="width: 100%; margin-left: 6%;">
                                    <label class="form-check-label link-dark px-1" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]="'Net'" name='tdsoption'
                                            [(ngModel)]="TDSOption" [disabled]="SectionType === ''">
                                        Net
                                    </label>
                                    <label class="form-check-label link-dark px-1" style="margin-left: 4%;"
                                        ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]="'Gross'" name='tdsoption'
                                            [(ngModel)]="TDSOption" [disabled]="SectionType === ''">
                                        Gross
                                    </label>
                                </div>
                                <label class="Label" style="margin-left: 6%;">
                                    TDS Value to be Round Off
                                    <input type="checkbox" [disabled]="SectionType === ''" [(ngModel)]="TDSvalue"
                                        name="tdsvalue" ngbCheckbox />
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header">
                        Tax Register
                    </div>
                    <div class="card-body">
                        <div class="row m-1">
                            <div class="col-md-2 px-1">
                                <label class="Label">VAT TIN NO</label>
                                <input name="vatino" [(ngModel)]="VatTinNo" type="text" class="form-control"
                                    maxlength="50" />
                            </div>
                            <div class="col-md-3 px-1">
                                <label class="Label">w.e.f</label>
                                <div class="input-group">
                                    <input class="form-control" name="vatweffeild" placeholder="Ex. DD MM YYYY"
                                        [(ngModel)]="VatNoDate" ngbDatepicker #d1="ngbDatepicker"
                                        [ngModelOptions]="{standalone: true}"
                                        [minDate]="{ year: 1930, month: 1, day: 1 }"
                                        [maxDate]="{ year: 2124, month: 12, day: 31 }" readonly />
                                    <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d1.toggle()"
                                        type="button" type="button"></button>
                                </div>
                            </div>
                            <div class="col-md-2 px-1">
                                <label class="Label">CST TIN NO</label>
                                <input name="cstino" [(ngModel)]="CstTinNo" type="text" class="form-control"
                                    maxlength="50" />
                            </div>
                            <div class="col-md-3 px-1">
                                <label class="Label">w.e.f</label>
                                <div class="input-group">
                                    <input class="form-control" name="cstweffeild" placeholder="Ex. DD MM YYYY"
                                        [(ngModel)]="CSTNoDate" ngbDatepicker #d2="ngbDatepicker"
                                        [ngModelOptions]="{standalone: true}"
                                        [minDate]="{ year: 1930, month: 1, day: 1 }"
                                        [maxDate]="{ year: 2124, month: 12, day: 31 }" readonly />
                                    <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d2.toggle()"
                                        type="button" type="button"></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header">
                        When Credit Limit of Party has Exceeded the specified limit, then
                        :
                    </div>
                    <div class="card-body">
                        <label class="form-check-label link-dark px-1" ngbButtonLabel>
                            <input class="form-check-input" type="radio" [value]="'D'" name='creditlimitopt'
                                [(ngModel)]="CreditLimitOpt">
                            Save the Invoice but don't allow
                            Print
                        </label><br>
                        <label class="form-check-label link-dark px-1" ngbButtonLabel>
                            <input class="form-check-input" type="radio" [value]="'M'" name='creditlimitopt'
                                [(ngModel)]="CreditLimitOpt">
                            Save Invoice but Show
                            Message
                        </label>
                        <br>
                        <label class="form-check-label link-dark px-1" ngbButtonLabel>
                            <input class="form-check-input" type="radio" [value]="'S'" name='creditlimitopt'
                                [(ngModel)]="CreditLimitOpt">
                            Save Invoice without showing any
                            Message
                        </label>
                        <br>
                        <label class="form-check-label link-dark px-1" ngbButtonLabel>
                            <input class="form-check-input" type="radio" [value]="'N'" name='creditlimitopt'
                                [(ngModel)]="CreditLimitOpt">
                            Don't Save the Invoice
                        </label>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header">
                        Bankers Particulars
                    </div>
                    <div class="card-body">
                        <div class="row m-1">
                            <div class="col-md-3 px-1">
                                <label class="Label">Name Of the Bank</label>
                                <input name="nameofbank" type="text" [(ngModel)]="NameOfBank" class="form-control"
                                    maxlength="50" />
                            </div>
                            <div class="col-md-3 px-1">
                                <label class="Label">Account Number</label>
                                <input name="accountnumber" type="text" [(ngModel)]="AccountNumber" class="form-control"
                                    maxlength="50" />
                            </div>
                            <div class="col-md-3 px-1">
                                <label class="Label">IFSC Code</label>
                                <input name="rtgscode" type="text" [(ngModel)]="RTGSCode" class="form-control"
                                    maxlength="50" />
                            </div>
                            <div class="col-md-3 px-1">
                                <label class="Label">MICR Code</label>
                                <input name="micrcode" type="text" [(ngModel)]="MICRCode" class="form-control"
                                    maxlength="50" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header">
                        Other Details
                    </div>
                    <div class="card-body">
                        <!-- <div class="row m-1">
                            <div class="col-md-3 px-1">
                                <label class="Label" style="margin-left: 3%;">
                                    Bill To/ Ship To Select
                                    <input type="checkbox" name="billtooption" [(ngModel)]="BillToOption"
                                        (change)="checkboxChanged('BillToShipTo')" ngbCheckbox />
                                </label>
                            </div>
                            <div class="col-md-1 px-1">
                                <label class="Label">Bill To :</label>
                            </div>
                            <div class="col-md-3 px-1">
                                <div class="btn-group btn-group-toggle" style="width: 100%;">
                                    <label class="form-check-label link-dark px-1" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]="'Site'" name='billto'
                                            [disabled]="!BillToOption" [(ngModel)]="BillTo">
                                        Site
                                    </label>
                                    <label class="form-check-label link-dark px-1" style="margin-left: 4%;"
                                        ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]="'Client'" name='billto'
                                            [disabled]="!BillToOption" [(ngModel)]="BillTo">
                                        Client
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-1 px-1">
                                <label class="Label">Ship To :</label>
                            </div>
                            <div class="col-md-3 px-1">
                                <div class="btn-group btn-group-toggle" style="width: 100%;">
                                    <label class="form-check-label link-dark px-1" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]="'Site'"
                                            [disabled]="!BillToOption" [(ngModel)]="ShipTo" name='shipto'>
                                        Site
                                    </label>
                                    <label class="form-check-label link-dark px-1" style="margin-left: 4%;"
                                        ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]="'Client'"
                                            [disabled]="!BillToOption" [(ngModel)]="ShipTo" name='shipto'>
                                        Client
                                    </label>
                                </div>
                            </div>
                        </div> -->
                        <!-- <div class="row m-1">
                            <div class="col-md-4 px-1">
                            </div>
                            <div class="col px-1">
                                <label class="Label" [style.color]="BillToOption ? 'green' : 'initial'">This will be
                                    only
                                    Applicable in Sitewise
                                    Billing!</label>
                            </div>
                        </div> -->
                        <!-- <hr> -->
                        <div class="row m-1">
                            <div class="col-md-4 px-1">
                                <label class="Label">Bank Marking</label>
                                <!-- <ng-select name="bankmarking" [items]="BankNameLoad" bindLabel="BankName"
                                    bindValue="OurCompanyBankMasterID" (change)="onSelectChange('BankMarking')"
                                    [(ngModel)]="OurBankID">
                                    <ng-option *ngFor="let segment of BankNameLoad"
                                        [value]="segment.OurCompanyBankMasterID">
                                        {{ segment.BankName }}
                                    </ng-option>
                                </ng-select> -->
                                <ng-select name="bankmarking" [items]="BankNameLoad" bindLabel="BankName"
                                    bindValue="OurCompanyBankMasterID" [(ngModel)]="OurBankID"
                                    placeholder="Select Bank Marking">
                                </ng-select>
                            </div>
                            <div class="col-md-3 px-1">
                                <label class="Label">Credit Limit</label>
                                <input name="creditlimit" type="text" [(ngModel)]="CreditLimit" class="form-control" />
                            </div>
                            <div class="col-md-2 px-1"><br>
                                <label class="Label" style="margin-left: 4%;">Customer Type :</label>
                            </div>
                            <div class="col-md-3 px-1"><br>
                                <div class="btn-group btn-group-toggle" style="width: 100%;">
                                    <label class="form-check-label link-dark px-1" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]="'PANIndia'"
                                            name='panindia' [(ngModel)]="CustomerType">
                                        PAN India
                                    </label>
                                    <label class="form-check-label link-dark px-1" style="margin-left: 4%;"
                                        ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]="'Local'" name='panindia'
                                            [(ngModel)]="CustomerType">
                                        Local
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="row m-1" style="padding-top: 8px;">
                            <div class="col-md-2 px-1">
                                <label class="Label" style="margin-left: 3%;">
                                    Auto Mail
                                    <input type="checkbox" name="automail" [(ngModel)]="AutoMail" ngbCheckbox />
                                </label>
                            </div>
                            <!-- <div class="col-md-3 px-1">
                                <label class="Label">Place Of Supply Applicable</label>
                            </div>
                            <div class="col px-1">
                                <div class="btn-group btn-group-toggle" style="width: 100%;">
                                    <label class="form-check-label link-dark px-1" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]="'Y'" name='placeofsupply'
                                            [(ngModel)]="PlaceOfSupplyOpt">
                                        Yes
                                    </label>
                                    <label class="form-check-label link-dark px-1" style="margin-left: 4%;"
                                        ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]="'N'" name='placeofsupply'
                                            [(ngModel)]="PlaceOfSupplyOpt">
                                        No
                                    </label>
                                </div>
                            </div> -->
                        </div>
                        <hr>
                        <div class="row m-1">
                            <div class="col-md-5 px-1">
                                <label class="Label">Commissionerate</label>
                                <input name="commissionerate" type="text" [(ngModel)]="Commissionerate"
                                    class="form-control" />
                            </div>
                            <div class="col-md-5 px-1">
                                <label class="Label">Collectorate</label>
                                <input name="collectorate" type="text" [(ngModel)]="Collectorate"
                                    class="form-control" />
                            </div>
                        </div>
                        <hr>
                        <div class="row m-1">
                            <div class="col-md-2 px-1"><br>
                                <label class="Label" style="margin-left: 3%;">
                                    MSME Client
                                    <input type="checkbox" name="Msmeclient" (change)="checkboxChanged('MSMEClient')"
                                        [(ngModel)]="MSMEClient" ngbCheckbox />
                                </label>
                            </div>
                            <div class="col-md-2 px-1">
                                <label class="Label">MSME Type</label>
                                <ng-select name="msmetype" [items]="MsMeLoad" bindLabel="MasterName"
                                    bindValue="MasterCode" (change)="onSelectChange('Msme')"
                                    [(ngModel)]="MsmeMasterCode" [disabled]="!MSMEClient">
                                    <ng-option *ngFor="let segment of MsMeLoad" [value]="segment.MasterCode">
                                        {{ segment.MasterName }}
                                    </ng-option>
                                </ng-select>
                            </div>
                            <div class="col-md-2 px-1">
                                <label class="Label">MSME No.</label>
                                <input name="msmeno" type="text" class="form-control" [(ngModel)]="MSMENo"
                                    [disabled]="!MSMEClient" maxlength="50" />
                            </div>

                            <div class="col-md-3 px-1">
                                <label class="Label">Date Of Registration</label>
                                <div class="input-group">
                                    <input class="form-control" name="dateofregFeild" placeholder="Ex. DD MM YYYY"
                                        [(ngModel)]="DateOfReg" [disabled]="!MSMEClient" ngbDatepicker
                                        #d3="ngbDatepicker" [ngModelOptions]="{standalone: true}"
                                        [minDate]="{ year: 1930, month: 1, day: 1 }"
                                        [maxDate]="{ year: 2124, month: 12, day: 31 }" readonly />
                                    <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d3.toggle()"
                                        type="button" type="button"></button>
                                </div>
                            </div>
                            <div class="col-md-3 px-1">
                                <label class="Label">Date Of Declaration</label>
                                <div class="input-group">
                                    <input class="form-control" name="dateofdecFeild" placeholder="Ex. DD MM YYYY"
                                        [(ngModel)]="DateOfDecl" [disabled]="!MSMEClient" ngbDatepicker
                                        #d4="ngbDatepicker" [ngModelOptions]="{standalone: true}"
                                        [minDate]="{ year: 1930, month: 1, day: 1 }"
                                        [maxDate]="{ year: 2124, month: 12, day: 31 }" readonly />
                                    <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d4.toggle()"
                                        type="button" type="button"></button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-header">
                            Lower TDS Deduction
                        </div>
                        <div class="card-body">
                            <!-- <div class="row m-1">
                                
                            </div> -->

                            <div class="row m-1">

                                <div class="col-md-4 px-1 mt-2">
                                    <div class="d-flex align-items-center mt-2">
                                        <label class="Label">Lower TDS Applicable</label>
                                        <input type="checkbox" class="form-check-input ms-2" id="checkbox"
                                            name="isuniformdeposit" [(ngModel)]="LowerTDSApplicable" />
                                    </div>
                                </div>

                                <div class="col-md-4 px-1">
                                    <label class="Label">Certificate No.</label>
                                    <input [disabled]="!LowerTDSApplicable" name="LowerTDSCertificateNo" type="text"
                                        class="form-control" [(ngModel)]="LowerTDSCertificateNo"
                                        placeholder="Certificate no" />
                                </div>

                                <div class="col-md-4 px-1">
                                    <label class="Label">Valid From</label>
                                    <div class="input-group">
                                        <input class="form-control" name="tdsvalidfrom" placeholder="Ex. DD MM YYYY"
                                            [(ngModel)]="LowerTDSValidFrom" [disabled]="!LowerTDSApplicable"
                                            ngbDatepicker #d5="ngbDatepicker" [ngModelOptions]="{standalone: true}" />
                                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d5.toggle()"
                                            type="button" type="button"></button>
                                    </div>
                                </div>
                            </div>

                            <div class="row m-1">

                                <div class="col-md-4 px-1">
                                    <label class="Label">Valid To</label>
                                    <div class="input-group">
                                        <input class="form-control" name="tdsvalidto" placeholder="Ex. DD MM YYYY"
                                            [(ngModel)]="LowerTDSValidTo" [disabled]="!LowerTDSApplicable" ngbDatepicker
                                            #d6="ngbDatepicker" [ngModelOptions]="{standalone: true}" />
                                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d6.toggle()"
                                            type="button" type="button"></button>
                                    </div>
                                </div>

                                <div class="col-md-4 px-1">
                                    <label class="Label">TDS Percentage</label>
                                    <input [disabled]="!LowerTDSApplicable" name="LowerTDSPercentage" type="text"
                                        class="form-control" [(ngModel)]="LowerTDSPercentage"
                                        placeholder="TDS percentage" (keypress)="onKeyPressPercentage($event)" />
                                </div>

                                <div class="col-md-4 px-1">
                                    <label class="Label">TDS Amount</label>
                                    <input [disabled]="!LowerTDSApplicable" name="LowerTDSAmount" type="text"
                                        class="form-control" [(ngModel)]="LowerTDSAmount" placeholder="TDS Amount"
                                        (keypress)="onKeyPressAmount($event)" />
                                </div>

                                <!-- <div class="col-md-4 px-1"> -->

                                <!-- </div> -->
                            </div>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-header">
                            Agreement Details
                        </div>
                        <div class="card-body">
                            <div class="row m-1">
                                <div class="col-md-3 px-1">
                                    <label class="Label">Start Date</label>
                                    <div class="input-group">
                                        <input class="form-control" name="agreementstartdate"
                                            placeholder="Ex. DD MM YYYY" [(ngModel)]="AgreementStartDate" ngbDatepicker
                                            #d7="ngbDatepicker" [ngModelOptions]="{standalone: true}" />
                                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d7.toggle()"
                                            type="button" type="button"></button>
                                    </div>
                                </div>

                                <div class="col-md-3 px-1">
                                    <label class="Label">End Date</label>
                                    <div class="input-group">
                                        <input class="form-control" name="agreementenddate" placeholder="Ex. DD MM YYYY"
                                            [(ngModel)]="AgreementEndDate" ngbDatepicker #d8="ngbDatepicker"
                                            [ngModelOptions]="{standalone: true}" />
                                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d8.toggle()"
                                            type="button" type="button"></button>
                                    </div>
                                </div>

                                <div class="col-md-6 px-1">
                                    <label class="Label">Agreement Attachment</label>
                                    <div class="file-input-container">
                                        <input class="form-control form-control-sm mt-1" id="formFileSm" type="file"
                                            *ngIf="!AgreementAttachment" (change)="onFileSelected($event)"
                                            accept=".pdf,image/*" />
                                        <span style="font-size: 14px" *ngIf="AgreementAttachment"
                                            class="file-name ms-1">{{
                                            AgreementAttachment
                                            }}</span>
                                        <span *ngIf="AgreementAttachment"> <button class="btn btn-sm" name="view"
                                                type="button" style="color: blue;" (click)="viewFile()"><i
                                                    class="bi bi-eye"></i></button></span>
                                        <button class="btn btn-sm" name="delete" type="button"
                                            *ngIf="AgreementAttachment" (click)="removeFile()">
                                            <i class="bi bi-trash text-danger"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="card-footer">
                    <div class="row">
                        <div class="col">
                            <div class="row">
                                <label class="Label"></label>
                            </div>
                            <div class="row">
                                <label class="Label"></label>
                            </div>
                            <div class="row">
                            </div>
                            <div class="row">
                            </div>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-outline-secondary btn-sm mx-2" [disabled]="isDisabled"
                                (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Cancel':'Loading...'}}</button>&nbsp;
                            <button class="btn btn-sm btn-primary" name="btn4" (click)="goToNextTab('Tab4')"><i
                                    class="bi bi-save"> </i>
                                Save & Next</button>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </li>
    <li [ngbNavItem]="5">
        <button ngbNavLink><i class="bi bi-terminal-fill"></i></button>
        <span class="stepper-text">Terms</span>
        <ng-template ngbNavContent><br>
            <div class="card">
                <div class="card-header">
                    Terms
                </div>
                <div class="card-body">
                    <div class="row m-1">
                        <div class="col-md-9 px-1">
                            <label class="Label">Notes</label>
                            <textarea type="text" id="proddesp" name="notes"
                                class="md-textarea md-textarea-auto form-control" rows="10" maxlength="2000"
                                style="resize: none; height: 22px;" [(ngModel)]="Notes" mdbInput></textarea>
                        </div>
                    </div>
                    <div class="row m-1">
                        <div class="col-md-9 px-1">
                            <label class="Label">Default Narration</label>
                            <textarea type="text" id="proddesp" name="defaultnarration"
                                class="md-textarea md-textarea-auto form-control" rows="10"
                                style="resize: none; height: 22px;" [(ngModel)]="DefaultNarration" maxlength="2000"
                                mdbInput></textarea>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="row">
                        <div class="col">
                            <div class="row">
                                <label class="Label"></label>
                            </div>
                            <div class="row">
                                <label class="Label"></label>
                            </div>
                            <div class="row">
                            </div>
                            <div class="row">
                            </div>
                        </div>
                        <div class="col-auto">
                            <!-- <button class="btn btn-sm btn-primary" name="btn5" (click)="save()">
                                <i class="bi bi-save"> </i>
                                Save</button> -->
                            <button type="button" class="btn btn-outline-secondary btn-sm mx-2" [disabled]="isDisabled"
                                (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Cancel':'Loading...'}}</button>&nbsp;
                            <button
                                *ngIf="(this.common.PageRight.IsAdd && this.Clientdatafrmview.ClientGroupMasterID == '') || (this.common.PageRight.IsEdit && this.Clientdatafrmview.ClientGroupMasterID != '')"
                                class="btn btn-sm btn-primary" name="btn5" (click)="save()">
                                <i class="bi bi-save" *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Save':'Loading...'}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </ng-template>
    </li>
</ul>
<div [ngbNavOutlet]="nav" class="mt-2"></div>